import 'es6-promise/auto'

import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    page: {},
    therapie: {},
    kurs: {},
    eigenschaften: [],
    filter: {
      type: [],
      insur: [],
      terms: [],
      konfriedlator: []
    },
    gruppen: [],
    leistungstypen: [],
    leistungscats: [],
    kurstypen: [],
    versicherungen: ['Privatleistung', 'Kassenleistung'],
    posts: [],
    all: [],
    haus: [],
    leistungen: [],
    kurse: [],
    subpages: {},
    searchterm: '',
    smalllayout: false,
    groupicons: ['yingyang', 'spring', 'bolt', 'pot', 'stetoskop'],
    filteredLength: 0,
    kursmode: 'info',
    selectedKurs: 0,
    konfriedlator: {}
  },
  actions: {
    getPageBySlug(store, {slug, type, id, nonce}) {
      store.commit('emptyPage')

      let request = '/wp-json/wp/v2/' + type + '?_embed&slug=' + slug
      if (nonce) {
        request = '/wp-json/wp/v2/' + type + '/' + id + '/revisions/?_wpnonce=' + nonce
      }
      Axios.get(request, {
        withCredentials: true
      }).then(function (response) {

        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        // console.log(response);
        store.commit('save' + type, response.data);
        // console.log('cached', response.url);
      });
    },
    getPageByParent(store, id) {
      Axios.get('/wp-json/wp/v2/pages?_embed&orderby=menu_order&order=asc&parent=' + id).then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveSubpages', response.data);
      });
    },
    getAll(store) {
      Axios.get('/wp-json/wp/v2/leistungen?per_page=100&orderby=menu_order&order=asc&_embed').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveAllLeistungen', response.data);
        store.dispatch('getKurse')
      });
    },
    getKurse(store) {
      Axios.get('/wp-json/wp/v2/kurse?per_page=100&orderby=menu_order&order=asc&_embed').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveAll', response.data);
      });

    },
    getPosts(store) {
      Axios.get('/wp-json/wp/v2/posts?per_page=200').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('savePosts', response.data);
      });
    },
    getHaus(store) {
      Axios.get('/wp-json/wp/v2/haus?per_page=20&orderby=menu_order&order=asc').then(function (response) {
        // window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveHaus', response.data);
      });
    },
    getTerms(store) {
      Axios.get('/wp-json/tag-groups/v1/terms/').then(function (response) {
        window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveTerms', response.data);
      });
    },
    getTermgroups(store) {
      Axios.get('/wp-json/tag-groups/v1/groups/').then(function (response) {
        window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveTermgroups', response.data);
      });
    },
    getLCats(store) {
      Axios.get('/wp-json/wp/v2/leistungen_types').then(function (response) {
        window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveLCats', response.data);
      });
    },
    getLTypes(store) {
      Axios.get('/wp-json/wp/v2/leistungen_cats').then(function (response) {
        window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveLTypes', response.data);
      });
    },
    getKCats(store) {
      Axios.get('/wp-json/wp/v2/kurse_cats').then(function (response) {
        window.sessionStorage.setItem("CACHE_$" + response.url, JSON.stringify(response.data));
        store.commit('saveKCats', response.data);
      });
    },
    getKonfriedlator(store) {
      Axios.get('/wp-content/themes/friedl/konfriedlator.json').then(function (response) {
        store.commit('saveKonfriedlator', response);
      })
    },
  },
  mutations: {
    emptyPage(state) {

      state.page = {}
      state.kurs = {}
      state.therapie = {}

    },
    saveKonfriedlator(state, data) {
      state.konfriedlator = data.data;
    },
    savepages(state, data) {
      state.page = data[0];
    },
    saveleistungen(state, data) {
      if (data.length === 1)
        state.therapie = data[0];
      else state.therapie = []

    },
    saveLTypes(state, data) {
      state.leistungstypen = data
    },
    saveLCats(state, data) {
      state.leistungscats = data
    },
    saveKCats(state, data) {
      state.kurstypen = data
    },
    savekurse(state, data) {
      state.kurs = data[0];

    },
    saveSubpages(state, data) {
      state.subpages = data;
    },
    saveAllLeistungen(state, data) {
      state.leistungen = data;
      state.all = data
    },
    saveAll(state, data) {
      state.kurse = data;
      state.all = state.leistungen.concat(data)
    },
    savePosts(state, data) {
      state.posts = data
    },
    saveHaus(state, data) {
      state.haus = data;
    },
    saveTerms(state, data) {
      state.eigenschaften = data;
    },
    saveTermgroups(state, data) {
      state.gruppen = data;
    },
    smalllayout(state) {
      state.smalllayout = true
    },
    biglayout(state) {
      state.smalllayout = false
    },
    addFilter(state, data) {
      state.filter[data.type].push(data.id)
    },
    removeFilter(state, data) {
      state.filter[data.type].splice(data.index, 1)
    },
    emptyFilter(state, data) {
      state.filter[data.type] = []
    },
    undoLastFilter(state, data) {
      state.filter[data.type].splice(state.filter[data.type].length - 1, 1)
    },
    filteredLength(state, data) {
      state.filteredLength = data.results
    },
    triggerSearch(state, data) {
      state.searchterm = data.term;
    },
    setKursmode(state, val) {
      state.kursmode = val;
    },
    setSelectedKurs(state, val) {
      state.selectedKurs = val;
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js